import React, { useEffect, useState } from "react"
import {
    Row,
    Col,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    CardImg
} from "reactstrap"
import { AvForm } from 'availity-reactstrap-validation';

import PropertyService from "services/Admin/PropertyService";

function ShapeImgModal({ modal, toggle, index, id ,addImageHandler }) {
    const [img, setImg] = useState(null)
    const [images, setImgages] = useState([])
    const [selectedImages, setSelectedImgages] = useState([])

    const propertyService = new PropertyService()



    useEffect(() => {

        propertyService.getDropDown(null, "Left").then(res => {
            let selected = res.data.find(item => item.id === id)
            setImgages(selected?.images)
        })

    }, [id]);

    const checkExist = (id) => {

        const result = selectedImages.find(img => img.id === id)

        if (result) {
            return true
        } else {
            return false
        }
    }

    const toggleHandler = (id) => {
        if (checkExist(id)) {
            const updatedList = selectedImages.filter(img => img.id !== id)
            setSelectedImgages([...updatedList])
        } else {
            const result = images.find(img => img.id === id)

            setSelectedImgages([...selectedImages, result])

        }
    }
    return (
        <AvForm
            className='form-horizontal'
            onValidSubmit={(e, v) => {
                handleValidSubmit(e, v)
            }}>
            <Modal isOpen={modal} toggle={toggle} className="scrollbar-container mt-5">
                <ModalHeader toggle={toggle}>
                    Choose Images from Library
                <br />
                </ModalHeader>
                <ModalBody>
                    <Row>
                        <Col className="d-flex flex-wrap">
                            {images?.length > 0 ? images ?.map(item => {
                                return (
                                    <div key={item.id} className="mx-1 my-2 d-flex"
                                        style={{ width: "80px", height: "70px", border: checkExist(item.id) ? "2px solid black" : "none" }}
                                        onClick={() => toggleHandler(item.id)}>
                                        <img src={item.path} style={{ width: "100%", height: "100%", objectFit: "cover" }} />
                                    </div>
                                )
                            }) :<Col className="d-flex justify-content-center">
                            <p className="font-size-16 fw-bold my-4">Library is empty for this  Unit</p>
                            </Col>
                        }
                        </Col>

                    </Row>
                </ModalBody>

                <ModalFooter className="p-0 pt-1 m-0 d-flex justify-content-end">
                    <button
                        type='button'
                        onClick={toggle}
                        className='btn btn-secondary'>
                        Cancel
                        </button>
                    <button
                        type='button'
                        onClick={() => {
                            addImageHandler(selectedImages)
                        }}
                        className='btn btn-success'>
                        Submit
                        </button>
                </ModalFooter>
            </Modal>
        </AvForm>

    )
}

export default ShapeImgModal
